// Stylesheets
import './css/style.css';

// eslint-disable-next-line import/no-unresolved
import cssHasPseudo from 'css-has-pseudo/browser';
cssHasPseudo(document);

// JavaScript
import './js/script.js';
